export default function global(state={}, actions) {

  switch(actions.type) {

    default: {
      return state;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/global.js
 **/